import { Component, OnInit, ViewChild } from '@angular/core';
import { CdkPortalOutlet, PortalOutlet, Portal } from '@angular/cdk/portal';
import { PopupService } from '../../services/popup.service';
import { PopupState } from '../../models/popup.model';

@Component({
  selector: 'brn-generic-popup',
  templateUrl: './generic-popup.component.html',
  styleUrls: ['./generic-popup.component.scss'],
})
export class GenericPopupComponent implements OnInit {
  @ViewChild(CdkPortalOutlet, { static: false }) portalOutlet!: PortalOutlet;

  state: PopupState = { open: false, position: undefined };

  constructor(private popupService: PopupService) {}

  close(): void {
    this.popupService.close();
  }

  ngOnInit(): void {
    this.popupService.state.subscribe((state: PopupState) => {
      setTimeout(() => {
        this.state = state;
      }, 0);
    });

    this.popupService.portal.subscribe((portal: Portal<any>) => {
      if (portal) {
        this.portalOutlet.detach();
        this.portalOutlet.attach(portal);
      }
    });
  }
}
